import { render, staticRenderFns } from "./packageformodal.vue?vue&type=template&id=9a121dc2"
import script from "./packageformodal.vue?vue&type=script&lang=js"
export * from "./packageformodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports